"use strict";

(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var $body = $("body");
    var $header = $(".header");
    var winScrollTop = $win.scrollTop();
    var $heroVideo = $("#video-hero");
    var heroHeight = $heroVideo.outerHeight();
    var $mobileTabSelect = $(".js-tabs-mobile-menu");
    var isMobileView = $win.outerWidth() < 767;
    var $mobileSrollSection = $(".js-mobile-scroll");
    var $subNavSticky = $(".fixed-menu-holder .fixed__aside");
    var $subMenu = $(".sub-menu");
    var viewPortCenter = winScrollTop + $win.outerHeight() / 2;
    var $videoSection = $(".js-vimeo-video");
    var heroPlayer;
    var vimeoOptions = {
        muted: !0,
        background: !0,
        loop: !0,
    };
    var vimeoVideos = [];

    // Mobile Vh Bug Fix
    var vh;
    if ($win.outerWidth() < 1024) {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", vh + "px");
    }

    $win.on("orientationchange", function (event) {
        setTimeout(function () {
            vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", vh + "px");
        }, 800);
    });

    $(".js-nav-trigger").on("click", function (e) {
        e.preventDefault();
        $header.toggleClass("is-menu-expanded");
        $(".menu").scrollLock();
    });

    $(".nav-lang > a ").on("click", function (e) {
        e.preventDefault();
        $(this).parent().toggleClass("is-expanded");
    });

    $(".js-accordion .accordion__btn").on("click", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $accodrionSection = $this.parents(".accordion__section");
        var $mapImages = $(".js-map-images");

        activeAccMoveToViewPort($accodrionSection);

        $accodrionSection
            .toggleClass("is-expanded")
            .find(".accordion__body")
            .slideToggle()
            .parents(".accordion__section")
            .siblings()
            .removeClass("is-expanded")
            .find(".accordion__body")
            .slideUp();
        $accodrionSection.find(".slick-initialized").slick("refresh");

        if ($mapImages.length > 0) {
            var index = $accodrionSection.index();
            $($mapImages.find("li")[index])
                .toggleClass("is-open")
                .siblings()
                .removeClass("is-open");
        }
    });

    $(".video-section").on("click", function (e) {
        var $this = $(this);
        var video = $this.find("iframe")[0];
        if (video.length > 0) {
            var player = findVideoInArr(vimeoVideos, video);

            player.getPaused().then(function (paused) {
                if (!paused) {
                    $this.removeClass("is-play");
                    player.pause();
                }
            });
        }
    });

    $(".js-btn-video").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $videoHolder = $this.parents(".video-section");
        var video = $videoHolder.find("iframe")[0];
        var player = findVideoInArr(vimeoVideos, video);
        player.getPaused().then(function (paused) {
            if (paused) {
                $videoHolder.addClass("is-play");
                player.play();
            } else {
                $videoHolder.removeClass("is-play");
                player.pause();
            }
        });
        player.on("pause", function (data) {
            $videoHolder.removeClass("is-play");
        });
    });

    $(".js-scroll").on("click", function (e) {
        e.preventDefault();
        var position = $($(this).attr("href")).offset().top;

        $("body, html").animate(
            {
                scrollTop: position,
            },
            1000
        );
    });

    $(".js-scroll-to-reg").on("click", function (e) {
        e.preventDefault();
        var $item = $($(this).attr("href"));
        var $scroller = $(".register");
        var position =
            $scroller.scrollTop() +
            $item.position().top -
            $(".register .register__title").outerHeight();

        if (isMobileView) {
            if (!$(".register").hasClass("register--popup")) {
                $scroller = $("body, html");
                position = $item.offset().top;
            }
        }

        $scroller.animate(
            {
                scrollTop: position,
            },
            1000
        );
    });

    $mobileTabSelect.on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("is-expanded");
    });

    $(".js-tabs .tabs__nav a").on("click", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $listItem = $this.parent();
        var listIndex = $listItem.index();
        var $section = $listItem.parents(".js-tabs");
        var $tabs = $section.find(".tab");
        $mobileTabSelect
            .removeClass("is-expanded")
            .find("p")
            .html($this[0].innerText);
        $listItem.addClass("is-active").siblings().removeClass("is-active");
        $tabs.eq(listIndex).fadeIn().siblings().hide();

        if (isMobileView) {
            mobileScrollSlider();
        }
    });

    function activeAccMoveToViewPort($activeAccItem) {
        var passedViewPortCenter = viewPortCenter < $activeAccItem.offset().top;

        if (passedViewPortCenter) {
            setTimeout(function () {
                $("body, html").animate(
                    {
                        scrollTop:
                            $activeAccItem.offset().top -
                            $win.outerHeight() / 2,
                    },
                    300
                );
            }, 500);
        }
    }

    function intVideos() {
        if (!$videoSection.length) {
            return;
        }

        $videoSection.each(function (inx, element) {
            vimeoVideos.push({
                player: new Vimeo.Player(element, vimeoOptions),
                element: element,
            });
        });
    }

    function videoIntroInt() {
        if (!$videoSection.length) {
            return;
        }
        if (typeof $heroVideo[0] != "undefined") {
            heroPlayer = findVideoInArr(vimeoVideos, $heroVideo[0]);
            heroPlayer.play();
        }
    }

    function playHeroVideoOnScroll() {
        if (winScrollTop < heroHeight) {
            heroPlayer.getPaused().then(function (paused) {
                if (paused) {
                    heroPlayer.play();
                }
            });
        }
    }

    function findVideoInArr(arr, search) {
        var result;

        jQuery.each(arr, function (ind, el) {
            if (el.element == search) {
                result = el;
            }
        });

        var player = result.player;
        return player;
    }

    function galleryPopup() {
        $(".js-gallery-popup").magnificPopup({
            type: "inline",
            preloader: false,
            modal: true,
            fixedContentPos: true,
            callbacks: {
                open: function open() {
                    var $this = this.content,
                        $slider = $this.find(".slick-initialized"),
                        $galleryPos = this.currItem.el.data("gallery-pos")
                            ? this.currItem.el.data("gallery-pos")
                            : 0;

                    $slider.slick("refresh").slick("slickGoTo", $galleryPos);
                },
            },
        });

        $(".popup-modal-dismiss").on("click", function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    }

    function sliderGallery() {
        // Popup gallery slider.
        var $sliderImage = $(".js-slider-image .slider__slides");

        $sliderImage.each(function (index, element) {
            var $this = $(element);
            addExtraSliderArrow($this);

            $this.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                cssEase: "linear",
                speed: 600,
                draggable: false,
                swipe: false,
                touchMove: false,
            });
        });

        // Non popup sliders.
        var $sliderBase = $(".js-slider-base .slider__slides");

        $sliderBase.each(function (index, element) {
            var $this = $(element);
            addExtraSliderArrow($this);

            $this.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: false,
                swipe: false,
                touchMove: false,
                adaptiveHeight: true,
            });
        });
        
        $doc.on("click", ".slider__arrow-hidden--next", function (e) {
            e.preventDefault();
            var $slider = $(this).parents(".slider__slides");
            $slider.slick("slickNext");
        });
    
        $doc.on("click", ".slider__arrow-hidden--prev", function (e) {
            e.preventDefault();
            var $slider = $(this).parents(".slider__slides");
            $slider.slick("slickPrev");
        });
    }

    $doc.on("click", function (e) {
        var navLangSelected = $(e.target).parents(".nav-lang").length;

        if (!navLangSelected) {
            closeNavLang();
        }
    });

    var regPopupCounter = 0,
        delay = 2 * 60 * 1000;

    $doc.on("click", ".js-register-btn", function (e) {
        e.preventDefault();

        $.magnificPopup.close();

        if (
            regPopupCounter < 1 &&
            document.cookie.indexOf("130LC_popup_form_submitted") == -1
        ) {
            setTimeout(function () {
                openRegisterPopup();
            }, delay);

            regPopupCounter++;
        }
    });

    function openRegisterPopup() {
        var $regPopup = $("#reg-popup");

        if ($regPopup.hasClass("popup-open")) {
            $.magnificPopup.open({
                items: {
                    src: "#reg-popup",
                },
                type: "inline",
                showCloseBtn: false,
                fixedContentPos: true,
                mainClass: "reg-popup",
            });
        }
    }

    function animateOnScroll() {
        $(".js-animate").each(function (index, element) {
            var $this = $(element);
            var animateStart = $this.attr("data-start");
            var sectionTop = $this.offset().top;
            var sectionHeight = $this.outerHeight();
            var scrollBottom = winScrollTop + $win.outerHeight();
            var sectionStartPosition = sectionHeight * animateStart;

            if (isMobileView) {
                sectionStartPosition = 50;
            }

            if (sectionTop + sectionStartPosition < scrollBottom) {
                $this.addClass("is-animated");
            }
        });
    } // mapStart

    $(".js-map-acc .accordion__btn").on("click", function (e) {
        var selectedMarkers = $(this)
            .parents(".accordion__section")
            .data("markers");
        var isAccOpen = $(this)
            .parents(".accordion__section")
            .hasClass("is-expanded");

        if (!isAccOpen) {
            clearMapMarkers();
        } else {
            // moveMap(loadAjax(selectedMarkers));
            moveMap(selectedMarkers);
        }
    });
    $doc.on("click", ".js-map-move", function (e) {
        e.preventDefault();
        var $this = $(this);
        var lat = $this.attr("data-lat");
        var lng = $this.attr("data-lang");
        $(".js-map-move").removeClass("is-active");
        $this.addClass("is-active");
        mapPanTo(lat, lng);
    });

    function loadAjax(filePath) {
        return $.ajax({
            async: false,
            global: false,
            url: filePath,
        }).responseJSON;
    }

    var itemNumber = 0;

    jQuery.each(
        $(".js-map-acc .accordion__section"),
        function (index, element) {
            var $section = $(this);
            var $sectionList = $section.find(".js-list-locations");
            // var thisData = loadAjax($section.data("markers"));

            var thisData = $section.data("markers");

            for (var i = 0; i < thisData.markers.length; i++) {
                var numberToAppend;
                var title = thisData.markers[i].title;
                // var numb = thisData.markers[i].number;
                var numb = i + 1;
                var content = thisData.markers[i].content;
                var lat = thisData.markers[i].position.lat;
                var lang = thisData.markers[i].position.lng;
                itemNumber++;

                if (itemNumber < 10) {
                    numberToAppend = "0" + itemNumber;
                } else {
                    numberToAppend = itemNumber;
                }

                $sectionList.append(
                    '<li><a href="#" class="js-map-move" data-lat="' +
                        lat +
                        '" data-lang="' +
                        lang +
                        '"><h3><span>' +
                        numb +
                        " </span> " +
                        title +
                        " </h3><h5> " +
                        content +
                        " </h5></a></li>"
                );
            }
        }
    );

    var $activeMarkers = $(".accordion__section.is-expanded");
    // var markers = loadAjax($activeMarkers.data("markers"));
    var markers = $activeMarkers.data("markers");
    var mapStyles = loadAjax($(".map-canvas .map__inner").data("styles"));
    var mapIcon = main_theme.template_url + "/assets/dist/images/map-pin.png";
    var gMap = document.getElementById($(".map-canvas .map__inner").attr("id"));
    var refMarker = $(".map-canvas .map__inner").data("ref-marker");
    var mapMarkers = [];
    var bounds;
    var map;
    var infoWindow;

    window.mapsApiLoadCallback = function () {
        if (gMap != null) {
            map = google.maps.Map;
            bounds = new google.maps.LatLngBounds();
            initMap(markers);
        }
    };

    function initMap(markers) {
        for (var i = 0; i < markers.markers.length; i++) {
            bounds.extend(markers.markers[i].position);
        }

        map = new google.maps.Map(gMap, {
            styles: mapStyles,
        });
        map.fitBounds(bounds);
        addMarkers(markers);

        if (typeof refMarker === "object" && refMarker !== null) {
            addRefMarker(refMarker);
        }
    }

    function moveMap(newMarkers) {
        $(".js-map-move").removeClass("is-active");
        clearMapMarkers();
        addMarkers(newMarkers);
        var bounds = new google.maps.LatLngBounds();

        for (var i = 0; i < newMarkers.markers.length; i++) {
            bounds.extend(newMarkers.markers[i].position);
        }

        map.fitBounds(bounds);
    }

    function mapPanTo(lat, lng) {
        var latLng = new google.maps.LatLng(lat, lng);
        map.panTo(latLng);
        google.maps.event.addListenerOnce(
            map,
            "bounds_changed",
            function (event) {
                if (this.getZoom() < 17) {
                    this.setZoom(17);
                }
            }
        );
    }

    function addMarkers(markers) {
        var markersArr = markers.markers;
        var cityCircle = new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
        });

        for (var i = 0; i < markersArr.length; i++) {
            var marker = new google.maps.Marker({
                position: markersArr[i].position,
                map: map,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 15,
                    fillColor: "#7B7B7B",
                    strokeColor: "#000",
                    fillOpacity: 1,
                    strokeWeight: 0.4,
                },
                label: {
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    text: markersArr[i].number.toString(),
                },
                id: i,
            });
            mapMarkers.push(marker);
        }
    }

    function addRefMarker(refMarker) {
        var pos = {
            lat: refMarker.lat,
            lng: refMarker.lng,
        };
        var myPos = new google.maps.Marker({
            position: pos,
            map: map,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 10,
                fillColor: "#fff",
                strokeColor: "#000",
                fillOpacity: 1,
                strokeWeight: 11,
            },
        });
    }

    function clearMapMarkers() {
        for (var i = 0; i < mapMarkers.length; i++) {
            mapMarkers[i].setMap(null);
        }
    }

    function mobileScrollSlider() {
        if (!isMobileView && !!$mobileSrollSection.length) {
            return;
        }

        $mobileSrollSection.each(function (i, e) {
            var $scrollSection = $(e);
            var scrollWidth = 0;
            $scrollSection.find(".grid__col").each(function (index, element) {
                scrollWidth += $(element).outerWidth(true);
            });
            $scrollSection.find(".grid").css("min-width", scrollWidth);
        });
    } // Stiky Nav Functions

    if (!!$subNavSticky.length) {
        $subNavSticky.stick_in_parent();
    }

    function scrollActiveState() {
        $(".js-scroll-section").each(function (index, element) {
            var $section = $(element);
            var sectionStart = $section.offset().top;
            var sectionEnd = sectionStart + $section.outerHeight();

            if (sectionStart < viewPortCenter && viewPortCenter < sectionEnd) {
                setActiveClassToNav($subMenu.find("li").eq(index));
            }
        });
    }

    function setActiveClassToNav($navItem) {
        $navItem.addClass("is-active").siblings().removeClass("is-active");
    }
    if (!!$(".gfield_select").length) {
        $(".gfield_select").selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
        });
    }

    galleryPopup();

    var lastScroll = winScrollTop;
    var directionUp = false;

    function scrollDetect() {
        var tolerance = 5;

        if (
            lastScroll + tolerance < winScrollTop ||
            lastScroll - tolerance > winScrollTop
        ) {
            directionUp = lastScroll > winScrollTop;

            $body.toggleClass("page-scroll-up", directionUp);
            lastScroll = winScrollTop;
        }
    }

    function fixedNav() {
        var navHeight = $win.height() - 90;

        if (winScrollTop > 90) {
            $body.addClass("page-scroll-up");

            $header.addClass("header--become-solid").addClass("header--solid");
        } else {
            $body.removeClass("page-scroll-up");

            $header
                .removeClass("header--become-solid")
                .removeClass("header--solid");
        }
    }

    function closeNavLang() {
        $(".nav-lang").removeClass("is-expanded");
    }

    function addExtraSliderArrow($slider) {
        var $slides = $slider.find(".slider__slide");
        var buttons =
            "<a href='#' class='slider__arrow-hidden  slider__arrow-hidden--prev'></a><a href='#' class='slider__arrow-hidden  slider__arrow-hidden--next'></a>";

        $slides.each(function (index, element) {
            var $slide = $(element);
            $slide.append(buttons);
        });
    }

    function slideToForm() {
        var hash = $win[0].location.hash,
            $form_section = $(".section--form");

        if (hash === "#form" && $form_section.length > 0) {
            var pos =
                $form_section.eq(0).offset().top -
                $form_section.eq(0).css("margin-top").replace("px", "");

            $("body, html").animate(
                {
                    scrollTop: pos,
                },
                1000
            );
        }
    }

    function minHeight() {
        var $main = $("main"),
            footerHeight = $("footer").outerHeight(true),
            minHeight = $win.innerHeight() - footerHeight - $main.offset().top;

        $main.css("min-height", minHeight + "px");
    }

    function calcHeaderHeight() {
        let headerHeight = $header.outerHeight();

        let wrapper_el = document.querySelector(".wrapper");
        wrapper_el.style.setProperty(
            "--header-height",
            headerHeight.toString() + "px"
        );
    }

    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    $body.toggleClass("browser-safari", isSafari);

    $win.on("load", function () {
        intVideos();
        videoIntroInt();
        playHeroVideoOnScroll();
        slideToForm();
        sliderGallery();
    })
        .on("load resize", function () {
            isMobileView = $win.outerWidth() < 767;
            mobileScrollSlider();
            minHeight();
            calcHeaderHeight();
        })
        .on("load scroll", function () {
            winScrollTop = $win.scrollTop();
            viewPortCenter = winScrollTop + $win.outerHeight() / 2;

            animateOnScroll();
            scrollActiveState();
            closeNavLang();
            fixedNav();
        });
})(jQuery, window, document);
